import { ChangeDetectorRef, Component, Inject, Input, OnChanges, OnInit } from '@angular/core';
import { AddDocumentComponent } from '../add-document/add-document.component';
import { EntityService } from '../../entity.service';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
@Component({
  selector: 'app-document-events',
  templateUrl: './document-events.component.html',
  styleUrls: ['./document-events.component.scss']
})


export class DocumentEventsComponent implements OnInit, OnChanges {

  constructor(private _matDialog: MatDialog, private _documentService: EntityService, private _changeDetectorRef: ChangeDetectorRef) { }
  dcmntsLst
  @Input() cpmntData;
  enty_ky = 0;
  hndlr_nm = '';
  loader;
  @Input() getList: boolean = false;
  ngOnInit(): void {
    this.enty_ky = this.cpmntData.enty_ky;
    this.hndlr_nm = this.cpmntData.hndlr_nm;
    if (this.cpmntData) {
      this.getDocuments(this.enty_ky, this.hndlr_nm)
    }
  }
  ngOnChanges(changes) {
    if (changes.cpmntData) {
      this.getDocuments(changes.cpmntData.currentValue.enty_ky, changes.cpmntData.currentValue.hndlr_nm)
    }
    if (this.getList == true) {
      this.getDocuments(this.enty_ky, this.hndlr_nm)
    }
  }
  addNewDocument() {
    const dialogRef = this._matDialog.open(AddDocumentComponent, {
      data: {
        hndlr_nm: this.hndlr_nm,
        enty_ky: this.enty_ky
      }
    });

    dialogRef.afterClosed()
      .subscribe((result) => {
        this.getList = true
        this.getDocuments(this.enty_ky, this.hndlr_nm)
      });

  }

  getDocuments(enty_ky, hndlr_nm) {
    this.loader = true
    this._documentService.getDcmnts(enty_ky, hndlr_nm).subscribe(res => {
      this.loader = false
      if (res['status'] == 200) {
        this.dcmntsLst = res['data'];
        this._changeDetectorRef.markForCheck();
      }
      else {
        this._documentService.openSnackBar(res['message'], 'mat-warn');
      }
    });
  }
  openDialog(url) {
    this._matDialog.open(DialogDataExampleDialog, {
      data: {
        url: url
      }
    });
  }
  edtDcmnt(edtData) {
    const dialogRef = this._matDialog.open(AddDocumentComponent, {
      data: {
        hndlr_nm: this.hndlr_nm,
        enty_ky: this.enty_ky,
        edit_in: 1,
        editData: edtData
      }
    });

    dialogRef.afterClosed()
      .subscribe((result) => {
        this.getDocuments(this.enty_ky, this.hndlr_nm)
      });
  }
}

@Component({
  selector: 'dialog-data-example-dialog',
  templateUrl: './document-imageview.html',
})
export class DialogDataExampleDialog {
  constructor(@Inject(MAT_DIALOG_DATA) public data) { }
}